import React, { useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, SectionCard } from "@/components/shared";
import { Download, FileSpreadsheet } from "lucide-react";
import { toast } from "sonner";

const REPORTS = [
  { key: "partners", label: "Partners Master" },
  { key: "projects", label: "Projects & Pipeline" },
  { key: "dispatches", label: "Dispatch Register" },
  { key: "ledger", label: "Points Ledger" },
  { key: "redemptions", label: "Redemptions" },
];

export default function Reports() {
  const [busy, setBusy] = useState(null);

  const download = async (kind, label) => {
    setBusy(kind);
    try {
      const { data } = await api.get(`/reports/${kind}`);
      if (!data.length) { toast.error("No data to export"); return; }
      const keys = Object.keys(data[0]).filter((k) => typeof data[0][k] !== "object");
      const csv = [keys.join(","), ...data.map((r) => keys.map((k) => `"${String(r[k] ?? "").replace(/"/g, '""')}"`).join(","))].join("\n");
      const blob = new Blob([csv], { type: "text/csv" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a"); a.href = url; a.download = `${kind}_export.csv`; a.click();
      URL.revokeObjectURL(url);
      toast.success(`${label} exported (${data.length} rows)`);
    } catch { toast.error("Export failed"); }
    finally { setBusy(null); }
  };

  return (
    <div>
      <PageHeader title="Reporting & Export" subtitle="CSV/Excel exports across the network (Priority-2)." testid="reports-page" />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {REPORTS.map((r) => (
          <div key={r.key} className="card-surface p-5 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <span className="h-10 w-10 rounded-lg grid place-items-center bg-emerald-50"><FileSpreadsheet size={18} className="text-emerald-600" /></span>
              <div><p className="font-semibold text-slate-800">{r.label}</p><p className="text-xs text-slate-400">CSV download</p></div>
            </div>
            <button data-testid={`export-${r.key}`} disabled={busy === r.key} onClick={() => download(r.key, r.label)} className="flex items-center gap-1.5 text-sm text-white font-semibold px-3 py-2 rounded-lg" style={{ background: "var(--navy-800)" }}><Download size={15} /> {busy === r.key ? "…" : "Export"}</button>
          </div>
        ))}
      </div>
    </div>
  );
}
